import { RouteRecordRaw } from "vue-router";
import { hide } from '@popperjs/core';
type RouteItemsRaw = RouteRecordRaw | {
  meta: {
    hidden: boolean,
    svgIcon: string,
    fontIcon: string,
  },
}

// name必须全局唯一
const routeItems: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: " ",
    component: () => import("@/layout/None.vue"),
    children: [
      {  //首页
        path: "/",
        name: "dashboard",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          hidden: true,
          svgIcon: "media/icons/duotune/art/art002.svg",
          fontIcon: "bi-app-indicator",
        }
      },
      {  //layout构造器
        path: "/builder",
        name: "layoutBuilder",
        component: () => import("@/views/Builder.vue"),
        meta: {
          hidden: true,
          svgIcon: "media/icons/duotune/general/gen019.svg",
          fontIcon: "bi-layers",
        },
      },
      {  //账号设置
        path: "/profile/settings",
        name: "accountSettings",
        component: () => import("@/views/profile/Settings.vue"),
        meta: {
          svgIcon: "media/icons/duotune/communication/com006.svg",
          fontIcon: "bi-person",
        },
      },
    ],
  },
  {  //管理功能
    path: "/",
    name: "management",
    component: () => import("@/layout/None.vue"),
    children: [
      {  //智能选品
        path: "/",
        name: "selection.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/ecommerce/ecm007.svg",
          fontIcon: "intelligent-goods",
          permission: "selection"
        },
        children: [
          {  //我的选品方案
            path: "/selection/goods/my",
            name: "selection.my",
            component: () => import("@/views/selection/Programme.vue"),
          },
          {  //选品方案
            path: "/selection/goods",
            name: "selection.programme",
            component: () => import("@/views/selection/Programme.vue"),
          },
          {  //查看选品结果
            path: "/selection/goods-view/:id",
            name: "selection.view",
            component: () => import("@/views/selection/View.vue"),
            meta: { hidden: true },
          },
          {  //自定义排序
            path: "/selection/sorting",
            name: "selection.sorting",
            component: () => import("@/views/selection/CustomSorting.vue"),
            meta: { is_superuser: true }
          },
          {  //自定义排序指标
            path: "/selection/sortingkey/:sid",
            name: "selection.sortingKey",
            component: () => import("@/views/selection/CustomSortingKey.vue"),
            meta: { hidden: true },
          },
        ]
      },
      {  //推荐
        path: "/",
        name: "recommend.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/general/gen025.svg",
          fontIcon: "recommend",
          permission: "recommend"
        },
        children: [
          {  //商品推广配置
            path: "/recommend/programme",
            name: "recommend.programme",
            component: () => import("@/views/recommend/Programme.vue"),
          },
          {  //黑名单商品
            path: "/recommend/black",
            name: "recommend.blackPool",
            component: () => import("@/views/recommend/BlackPool.vue"),
          },
          {  //权重配置
            path: "/recommend/weight",
            name: "recommend.weight",
            component: () => import("@/views/recommend/Weight.vue"),
          },
          {  //季节配置
            path: "/recommend/season",
            name: "recommend.season",
            component: () => import("@/views/recommend/Season.vue"),
          },
        ]
      },
      {  //新品孵化
        path: "/",
        name: "incubation.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/communication/com001.svg",
          fontIcon: "incubation",
          permission: "incubation"
        },
        children: [
          {  //人工运营
            path: "/incubation/manual",
            name: "incubation.manual",
            component: () => import("@/views/incubation/ManualPool.vue"),
          },
        ]
      },
      {  //搜索
        path: "/",
        name: "search.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/general/gen021.svg",
          fontIcon: "search-keyword",
          permission: "search"
        },
        children: [
          {  //搜索词报表
            path: "/search/report",
            name: "search.report",
            component: () => import("@/views/search/Report.vue"),
          },
          {  //错词改写
            path: "/search/keycorr",
            name: "search.keyCorr",
            component: () => import("@/views/search/KeyCorr.vue"),
          },
          {  //同义词扩展
            path: "/search/keysynonym",
            name: "search.keySynonym",
            component: () => import("@/views/search/KeySynonym.vue"),
          },
          {  //关键词类目绑定
            path: "/search/keycat",
            name: "search.keyCat",
            component: () => import("@/views/search/KeyCat.vue"),
          },
          {  //跳转词设置
            path: "/search/keyredirect",
            name: "search.keyRedirect",
            component: () => import("@/views/search/KeyRedirect.vue"),
            meta: { hidden: true },
          },
          {  //关键词商品
            path: "/search/goods",
            name: "search.keywordGoods",
            component: () => import("@/views/search/KeyGoods.vue"),
          },
          {  //热搜词黑名单
            path: "/search/hot_blacklist",
            name: "search.hotBlacklist",
            component: () => import("@/views/search/HotBlacklist.vue"),
          },
          {  //热搜词置顶
            path: "/search/hot_topping",
            name: "search.hotTopWords",
            component: () => import("@/views/search/HotTopWords.vue"),
          },
        ]
      },
      {  //商品分析报表
        path: "/",
        name: "report.product.name",
        component: () => import("@/layout/None.vue"),
        meta: {
          svgIcon: "media/icons/duotune/graphs/gra001.svg",
          fontIcon: "report",
          permission: "report_product"
        },
        children: [
          {  //类目分析
            path: "/",
            name: "report.product.categoryName",
            component: () => import("@/layout/Site.vue"),
            children: [
              {  //类目概览
                path: "/report/product/category/overview",
                name: "report.product.categoryOverview",
                component: () => import("@/views/report/product/CategoryOverview.vue"),
              },
              {  //类目异动分析
                path: "/report/product/category/change",
                name: "report.product.categoryChange",
                component: () => import("@/views/report/product/CategoryChange.vue"),
              },
              {  //类目趋势明细
                path: "/report/product/category/trend",
                name: "report.product.categoryTrend",
                component: () => import("@/views/report/product/CategoryTrend.vue"),
              },
              {  //上新分析
                path: "/report/product/category/new",
                name: "report.product.categoryNew",
                component: () => import("@/views/report/product/CategoryNew.vue"),
              },
            ]
          },
          {  //商品分析
            path: "/",
            name: "report.product.productName",
            component: () => import("@/layout/Site.vue"),
            children: [
              {  //商品列表
                path: "/report/product/product/list",
                name: "report.product.productList",
                component: () => import("@/views/report/product/ProductList.vue"),
                meta: { hidden: true }
              },
              {  //商品概览
                path: "/report/product/product/overview",
                name: "report.product.productOverview",
                component: () => import("@/views/report/product/ProductOverview.vue"),
              },
              {  //商品明细数据
                path: "/report/product/product/details",
                name: "report.product.productDetails",
                component: () => import("@/views/report/product/ProductDetails.vue"),
              },
              {  //单品分析
                path: "/report/product/product/single",
                name: "report.product.productSingle",
                component: () => import("@/views/report/product/ProductSingle.vue"),
                meta: { hidden: true }
              },
            ]
          },
        ]
      },
      {  //栏位数据评估
        path: "/",
        name: "report.evaluation.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/coding/cod003.svg",
          fontIcon: "evaluation",
          permission: "evaluation"
        },
        children: [
          {  //栏位数据评估报表
            path: "/evaluation/report",
            name: "report.evaluation.report",
            component: () => import("@/views/report/evaluation/Report.vue"),
          },
        ]
      },
      {  //监控报表
        path: "/",
        name: "report.monitoring.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/coding/cod007.svg",
          fontIcon: "monitoring",
          permission: "monitoring"
        },
        children: [
          {  //推荐API调用量统计
            path: "/monitoring/apireport",
            name: "report.monitoring.report",
            component: () => import("@/views/report/monitoring/ApiReport.vue"),
          },
        ]
      },
      {  //广告运营
        path: "/",
        name: "ads.name",
        component: () => import("@/layout/Site.vue"),
        meta: {
          svgIcon: "media/icons/duotune/general/gen006.svg",
          fontIcon: "ads",
          permission: "ads"
        },
        children: [
          {  //推荐API调用量统计
            path: "/ads",
            name: "ads.platform",
            component: () => import("@/views/profile/Ads.vue"),
          },
        ]
      },
    ],
  },
  {  //系统
    path: "/system",
    name: "system.name",
    component: () => import("@/layout/None.vue"),
    children: [
      {  //系统管理，和站点id无关
        path: "/",
        name: "system.management",
        component: () => import("@/layout/None.vue"),
        meta: {
          svgIcon: "media/icons/duotune/coding/cod001.svg",
          fontIcon: "sys-management",
          is_staff: true
        },
        children: [
          {  //用户列表
            path: "/system/users",
            name: "system.usersList",
            component: () => import("@/views/system/management/UsersList.vue"),
            meta: {
              is_staff: true
            }
          },
          {  //企业列表
            path: "/system/customers",
            name: "system.customerList",
            component: () => import("@/views/system/management/CustomerList.vue"),
            meta: {
              is_superuser: true
            }
          },
          {  //站点列表
            path: "/system/sites",
            name: "system.siteList",
            component: () => import("@/views/system/management/SiteList.vue"),
            meta: {
              is_superuser: true
            }
          },
          {  //更新配置数据
            path: "/system/configuration",
            name: "system.configuration",
            component: () => import("@/views/system/management/Configuration.vue"),
            meta: {
              is_superuser: true
            }
          },
          {  //后台操作记录
            path: "/system/records",
            name: "system.records",
            component: () => import("@/views/system/management/OpRecords.vue"),
            meta: {
              is_superuser: true
            }
          },
          {  //日志采集数据
            path: "/system/collection",
            name: "system.collection",
            component: () => import("@/views/system/management/Collection.vue"),
            meta: {
              is_superuser: true
            }
          },
        ]
      },
      {  //站点模块管理，和站点id有关
        path: "/",
        name: "system.siteModule.name",
        component: () => import("@/layout/None.vue"),
        meta: {
          svgIcon: "media/icons/duotune/medicine/med005.svg",
          fontIcon: "sys-site-config",
          is_superuser: true,
        },
        children: [
          {  //智能选品配置
            path: "/system/sites/selection",
            name: "system.siteModule.selection",
            component: () => import("@/views/system/site-settings/Selection.vue"),
            meta: {
              is_superuser: true,
            },
          },
          {  //推荐配置
            path: "/system/sites/recommend",
            name: "system.siteModule.recommend",
            component: () => import("@/views/system/site-settings/Recommend.vue"),
            meta: {
              is_superuser: true,
            },
          },
          {  //搜索配置
            path: "/system/sites/search",
            name: "system.siteModule.search",
            component: () => import("@/views/system/site-settings/Search.vue"),
            meta: {
              is_superuser: true,
            },
          },
          {  //推荐接口配置
            path: "/system/envs",
            name: "system.siteModule.envs",
            component: () => import("@/views/system/site-settings/RecommendAPi.vue"),
            meta: {
              is_superuser: true,
            }
          },
          {  //商品分析报表配置
            path: "/system/report/product",
            name: "system.siteModule.product",
            component: () => import("@/views/system/site-settings/Product.vue"),
            meta: {
              is_superuser: true,
            }
          },
        ]
      },
    ],
    meta: {
      is_staff: true
    }
  },
]

export default routeItems;
